import { parsePhoneNumber, isValidPhoneNumber, AsYouType } from 'libphonenumber-js'
import i18n from 'i18next'
import { ConferenceNumbersDelimiter } from 'common/Globals'

export const trimSpecialChars = (number) => {
    return isString(number) && number.replace(/[\s\-().]+/g, '')
}

export const replaceOpeningZero = (number) => {
    return isString(number) && number.replace(/^00/, '+')
}

export const replaceOpeningPlus = (number) => {
    return isString(number) && number.replace(/^\+/, '00')
}

export const isString = (val) => typeof val === 'string'

export const numberValidationError = (number) => {
    return getCountryCode(number) ? i18n.t('countryNumberValidationError') : i18n.t('numberValidationError')
}

export const getCountryCode = (number) => {
    try {
        return parsePhoneNumber(prepareLibphonenumber(number).val, '').country
    } catch (e) {
        if (e?.message === 'INVALID_COUNTRY') {
            return getCountryCodeForcedPlus(number)
        }

        return ''
    }
}

export const getCountryCodeForcedPlus = (number) => {
    try {
        return parsePhoneNumber(`+${number}`, '').country
    } catch {
        return ''
    }
}

export const isPossible00InternationalNumber = (number) => {
    if (!isString(number)) return
    number = trimSpecialChars(number)
    return number.length > 3 && number.slice(0, 2) === '00'
}

export const prepareLibphonenumber = (number) => {
    const is00Number = isPossible00InternationalNumber(number)

    return {
        is00Number,
        val: is00Number ? replaceOpeningZero(number) : number
    }
}

export const parseForcedPlus = (number) => {
    if (number[0] !== '+') {
        const ccode = getCountryCodeForcedPlus(number)
        number = ccode ? `+${number}` : number
    }

    return number
}

export const validateNumber = (number) => {
    const acceptibleFormat = /^[+*]?[0-9]+[-* 0-9()]*$/
    return getCountryCode(number)
        ? isValidPhoneNumber(parseForcedPlus(prepareLibphonenumber(number).val))
        : acceptibleFormat.test(number)
}

export const formatAsYouType = (number) => {
    const preparedNumber = prepareLibphonenumber(number)
    const formattedNumber = new AsYouType().input(preparedNumber.val)
    const outputNumber = preparedNumber.is00Number ? replaceOpeningPlus(formattedNumber) : formattedNumber

    return getCountryCode(number) ? outputNumber : number
}

export const sipNumberFormat = (number) => {
    return trimSpecialChars(number)
}

export const visualNumberFormat = (number) => {
    return isString(number) && formatAsYouType(number)
}

export const joinConferenceCallNumbers = (numbers) => numbers.join(ConferenceNumbersDelimiter)

export const splitConferenceCallNumberString = (number) => number.split(ConferenceNumbersDelimiter)

export const removeConferenceCallNumber = (numberString, number) => {
    const numbersArr = splitConferenceCallNumberString(numberString)
    const newNumbers = numbersArr.filter(num => num !== number)
    return joinConferenceCallNumbers(newNumbers)
}

export const splitConferenceCallNumberArray = (numbersArray) => {
    const numbers = []

    for (const num of numbersArray) {
        numbers.push(num.includes(ConferenceNumbersDelimiter) ? splitConferenceCallNumberString(num) : num)
    }

    return numbers.flat()
}